/*
* Import Configurations for site gildedbox
* Don't use keys: dev, site, apiUrl
*/
import getMainConf from './settings/main'
import getServicesConf from './settings/services'
import getNavigationConf from './settings/navigation'
import getDesignerConf from './settings/designer'
import getCatalogConf from './settings/catalog'
import getProductConf from './settings/product'
import getPageConf from './settings/page'
import getSearchConf from './settings/search'
import getCustomerConf from './settings/customer'
import getCampaignsConf from './settings/campaigns'
import getCartConf from './settings/cart'
import getCheckoutConf from './settings/checkout'
import getMetaConf from './settings/meta'
import getWidgetsConf from './settings/widgets'
import getComponentsConf from './settings/components'
import getSchemeConf from './settings/scheme'

export default function (data) {
  /**
  * Return Object
  */
  return Object.assign({}, {
    confMain: getMainConf(data),
    confServices: getServicesConf(data),
    confNavigation: getNavigationConf(data),
    confDesigner: getDesignerConf(data),
    confCatalog: getCatalogConf(data),
    confProduct: getProductConf(data, getWidgetsConf(data)),
    confPage: getPageConf(data),
    confSearch: getSearchConf(data),
    confCustomer: getCustomerConf(data),
    confCampaigns: getCampaignsConf(data),
    confCart: getCartConf(data),
    confCheckout: getCheckoutConf(data),
    confMeta: getMetaConf(data),
    confWidgets: getWidgetsConf(data),
    confComponents: getComponentsConf(data),
    confScheme: getSchemeConf(data)
  }, useRuntimeConfig().public)
}
